import React from 'react';

import EmptyView from 'components/EmptyView';
import Button from 'components/Button';

interface IProps {
  onCreateProject: () => void;
}

const NoProjects = ({ onCreateProject }: IProps) => (
  <EmptyView>
    <span className="icon-no-projects" />
    <p>You have no projects </p>
    <p>
      Please{' '}
      <Button isLink onClick={onCreateProject}>
        create
      </Button>{' '}
      a project
    </p>
  </EmptyView>
);

export default NoProjects;
